export default __webpack_public_path__ + "static/media/about-section-img.00018880.JPG";